// Polish

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `aktualne do ${date}` : ''),
    },
    interview: {
      title: 'Odpowiedź do rozmowy wideo',
      submit: 'Wyślij odpowiedzi i zakończ rozmowę',
      continueLater: 'Kontynuuj później',
      startInterview: 'Rozpocznij rozmowę',
      duplicateError: 'Masz już za sobą tę rozmowę. Wysłaliśmy e-mail z adresu invitations@recright.com zawierający link, który można użyć do kontynuacji rozmowy.',
      confirmSubmitHeader: 'Nie udzielono odpowiedzi na wszystkie pytania rekrutacyjne',
      confirmSubmitContent: 'Na pewno chcesz zakończyć tę rozmowę?',
      confirmSubmitContentWarning: 'Nie będzie można w związku z tym ukończyć odpowiedzi.',
      submitInterviewHeader: 'Prześlij swoje odpowiedzi',
      submitInterviewContent: 'Czy na pewno chcesz przesłać swoją rozmowę?',
      confirmSubmitButton: 'Wyślij odpowiedzi i zakończ rozmowę',
      preview: 'Podgląd pytań jest dostępny tutaj.',
      withdrawLink: 'Nie interesuje Cię już to stanowisko? Wycofaj się z procesu rekrutacji tutaj.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Nazwa',
      city: 'Miejscowość',
      email: 'E-mail',
      phone: 'Numer telefonu',
      link: 'Link',
      legendBasicInfo: 'Dane podstawowe',
      placeholderName: 'Podaj imię i nazwisko',
      placeholderEmail: 'Podaj adres e-mail',
      placeholderPhone: 'Podaj numer telefonu',
      placeholderCity: 'Podaj miejscowość, w której mieszkasz',
      placeholderLink: 'Dodaj linki, na przykład do profilu na LinkedIn.',
      legendAttachments: 'Załączniki',
      legendAdditionalFields: 'Dane dodatkowe',
      required: 'Pola zaznaczone symbolem * są obowiązkowe.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Audio',
        video: 'Wideo',
        yes: 'Tak',
        no: 'Nie',
        supported: 'Wsparcie',
        quality: 'Jakość',
        header: 'Połączenie sieciowe i test urządzenia',
        description: 'Teraz przeprowadzimy test, aby upewnić się, że połączenie sieciowe i sprzęt potrzebny do rozmowy (kamera i telefon) działają poprawnie. Po wyświetleniu zapytania zezwól na użycie przez test zarówno kamery, jak i mikrofonu oraz upewnij się, że kamera nie jest przykryta. Test potrwa około 30 sekund. Zalecamy mówienie podczas testowania sprzętu.',
        inProgress: 'Test w toku ...',
        networkTestResults: 'Wyniki testu sieci',
        qualityTestResults: 'Wyniki testu jakości',
        testPassedQuality: 'Test jakości zdany',
        testFailedQuality: 'Test jakości połączenia zakończony niepowodzeniem',
        testPassedNetwork: 'Test połączenia sieciowego zakończony pomyślnie',
        testFailedNetwork: 'Test sieci nieudany',
        startTest: 'Rozpocznij test',
        startInterview: 'Rozpocznij rozmowę',
        testAgain: 'Testuj ponownie',
        confirmWarning: 'Po rozpoczęciu rozmowy wideo automatycznie wyświetli się pierwsze jej pytanie. Gdy się z nim zapoznasz, nastąpi przejście do etapu przygotowania.',
        confirmTitle: 'Zaraz zaczniesz rozmowę',
        confirmText: 'Przed każdym pytaniem masz krótką chwilę na przygotowanie się do odpowiedzi. Po przygotowaniu otrzymasz ustaloną ilość czasu na jej udzielenie. Pamiętaj, że jeśli zechcesz, możesz przesłać odpowiedź jeszcze przed jego upływem.',
        confirmText2: 'Po przesłaniu odpowiedzi przechodzisz do następnego pytania, aż do wyczerpania pytań.',
        confirmText3:
          'Pamiętaj, że po zapisaniu swojej odpowiedzi na pytanie masz 30 sekund na wprowadzenie ponownej odpowiedzi, jeśli jest to dozwolone w odniesieniu do danego pytania. Jeśli nie zainicjujesz ponownej próby w ciągu tych 30 sekund, Twoja bieżąca odpowiedź zostanie automatycznie przesłana i nastąpi przekierowanie do następnego pytania.',
        goodLuck: 'Weź głęboki oddech – poradzisz sobie. Powodzenia!',
        qualityRating: {
          excellent: 'Świetnie',
          good: 'Dobrze',
          fair: 'Przyzwoicie',
          poor: 'Kiepsko',
          bad: 'Źle',
        },
      },
      questionAnswerView: {
        title: title => `Odpowiedź na rozmowę ${title}`,
        question: 'Pytanie',
        submitAndNext: 'Prześlij i kontynuuj',
        submitSuccess: 'Przesłano wideo',
        skipText: 'Rozpocznij nagrywanie',
        stop: 'Zatrzymaj',
        submitAndFinish: 'Zapisz i zakończ rozmowę',
        retake: 'Kolejne podejście',
        take: 'Podejście',
        takesLeft: 'Pozostało podejść',
        skipTextQuestion: 'Gotowy? Ruszaj do przodu',
        retakeConfirmTitle: 'Czy na pewno chcesz udzielić ponownie odpowiedzi na to pytanie?',
        retakeConfirmSubmit: 'Tak, odpowiadam ponownie',
        submitInfoForward: 'Trwa automatyczne przesyłanie bieżącej odpowiedzi; przejście dalej nastąpi w ciągu',
        submitInfoForward2: 'sekund',
        nonAnswerableText: 'Ta wiadomość nie wymaga odpowiedzi. Po przeczytaniu wiadomości zostaniesz przeniesiony(-a) bezpośrednio do następnego pytania.',
        nonAnswerableVideo: 'Ten film nie wymaga odpowiedzi. Po filmie zostaniesz przeniesiony(-a) bezpośrednio do następnego pytania.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Masz ${answerMinutes} minut i ${answerSeconds} sekund, aby odpowiedzieć na pytanie.`,
      },
      publisher: {
        toNextQuestion: timer => `Przejście do następnego pytania za ${timer}`,
        recordingStarts: timer => `Nagrywanie rozpocznie się za ${timer}`,
      },
      errors: {
        tooManyConnections: 'To połączenie zostało zamknięte, ponieważ inne połączenie jest otwarte w innej zakładce lub oknie.',
        unsupportedBrowser: 'Ta operacja nie jest obsługiwana przez Twoją przeglądarkę. Użyj innej przeglądarki.',
        networkError: 'Brak połączenia z internetem.',
        reconnecting: 'Połączenie zostało przerwane. Próbuję połączyć się ponownie.',
        generalError: 'Wystąpił nieznany błąd. Odśwież stronę i spróbuj ponownie.',
        allowMediaDevicesError: 'Ta operacja nie ma dostępu do urządzeń multimedialnych (kamery lub mikrofonu). Upewnij się, że zezwoliłeś przeglądarce na używanie kamery i mikrofonu.',
        noAvailableDevicesError: 'Nie można znaleźć kamery ani mikrofonu.',
        initPublisherError: 'Operacja nie powiodła się z powodu błędu. Upewnij się, że zezwoliłeś przeglądarce na korzystanie z kamery i mikrofonu oraz że nie są one używane przez inną aplikację, a następnie spróbuj ponownie.',
      },
      browserInfo: {
        browserSupportTitle: 'Obsługa przeglądarek',
        supportedBrowsers: 'System do testów i rozmowy obsługuje najnowsze wersje przeglądarek Chrome, Firefox, Safari i Edge.',
        mobileSupported: 'Obsługiwane przeglądarki na urządzeniach mobilnych',
        android: 'Android: Google Chrome (najnowsza wersja), Firefox (najnowsza wersja)',
        iOS: 'iOS: Safari (najnowsza wersja)',
        latestVersion: 'Upewnij się, że używasz najnowszej wersji przeglądarki. Dzięki temu wszystko będzie działać płynnie.',
        freezeInstruction: 'Jeśli nagrywanie wideo nie rozpoczęło się lub ekran nagrywania pozostaje czarny, proszę odświeżyć stronę.',
        unsupportedOnIos: 'Wygląda na to, że używasz nieobsługiwanej przeglądarki na iOS. Użyj Safari.',
        ieUnsupported: 'Wygląda na to, że używasz Internet Explorera. System do testów i rozmów kwalifikacyjnych nie obsługuje Internet Explorera. Użyj innej przeglądarki.',
        qualityTestNotSupported: 'Używana przez Ciebie przeglądarka nie obsługuje testowania sprzętu. Możesz kontynuować rozmowę bez testowania jakości dźwięku i obrazu lub użyć innej przeglądarki.',
      },
      reconnectSuccess: 'Połączono ponownie!',
      continue: 'Kontynuuj',
    },

    withdraw: {
      title: 'Nie interesuje Cię już to stanowisko?',
      description: 'Wycofaj się z procesu rekrutacji.',
      buttonText: 'Wycofaj się z procesu rekrutacji',
      thankYouTitle: 'Dziękujemy.',
      thankYouText: 'Rekruterzy zostali poinformowani, że nie interesuje Cię już to stanowisko.',
      confirm: 'Czy na pewno chcesz wycofać się z procesu rekrutacji? Jeśli to zrobisz, stracisz możliwość wzięcia udziału w rozmowach kwalifikacyjnych związanych z tym stanowiskiem.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Złóż',
      continue: 'Kontynuuj',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Dziękujemy za odpowiedź filmową! Wkrótce się z Tobą skontaktujemy!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Dziękujemy za udział w rozmowie rekrutacyjnej!',
      reopenDescription: 'Jeśli zamkniesz wywiad przez przypadek, nie przejmuj się! Możesz go ponownie otworzyć, klikając przycisk poniżej.',
      reopenButtonText: 'Otwórz wywiad ponownie',
      description1: 'Znakomicie, udzielono odpowiedzi na wszystkie pytania i zostały one wysłane do odbiorcy.',
      descriptionsupport: mailto => `Jeśli rozmowa rekrutacyjna została zakończona przez pomyłkę, prosimy o kontakt z naszym działem obsługi klienta pod adresem ${mailto}, a udostępnimy ją ponownie.`,
      descriptionfeedback: 'Twoje wrażenia są dla nas bardzo ważne! Jak oceniasz naszą rozmowę rekrutacyjną w za pośrednictwem wideo? W jaki sposób można by ją poprawić? Podziel się z nami uwagami pod tym adresem.',
      feedbackbutton: 'Przekaż nam swoje uwagi!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Wiadomość osobista',
    },

    closed: {
      title: 'Rozmowa została zakończona lub przerwana',
      description: 'Rozmowa wideo, do której Cię zaproszono, została zakończona, a aplikacja wysłana.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Twoja rozmowa wideo została zapisana!',
      description: 'Kiedy zechcesz kontynuować rozmowę wideo, skorzystaj z linku, który wysłaliśmy Ci wcześniej na skrzynkę e-mail. Zapisane wcześniej odpowiedzi filmowe będą czekać na Ciebie, kiedy do nas wrócisz! Powodzenia w poszukiwaniach pracy!',
      remember: 'Pamiętaj, by wysłać odpowiedzi rekruterowi po udzieleniu odpowiedzi podczas rozmowy.',
      deleteHistory: 'Jeśli przeprowadzasz rozmowę wideo na komputerze ogólnie dostępnym, upewnij się, by po jej zakończeniu wyczyścić historię przeglądania. Dzięki temu Twoja rozmowa będzie bezpieczna.',
    },
    unpublished: {
      title: 'Rozmowa kwalifikacyjna nie jest jeszcze aktywna',
      publishTime: publishTime => `Rozmowa kwalifikacyjna stanie się aktywna ${publishTime}`,
    },
  },
}
